import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import IconLarge from "../../../hiberUiKit/src/atoms/Icon/IconLarge";
import IconWrapper from "../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import "./commonDetailsStatusRow.scss";
import classNames = require("classnames");

export interface DetailsStatusPathItem {
	label: string,
	onClick?: () => void
}

interface IProps {
	/**
	 * Icon to be displayed next to the back button.
	 */
	icon?: string;
	/**
	 * Title of displayed data.
	 */
	title: string;
	/**
	 * Back icon click callback.
	 */
	onBackClick?: () => void;
	/**
	 * Text to be displayed in status wrapper.
	 */
	status?: string;
	/**
	 * Custom status component.
	 */
	customStatusComponent?: JSX.Element;
	/**
	 * Additional component to be displayed next to status.
	 */
	additionalComponent?: JSX.Element;
	/**
	 * Additional component to be displayed on the right
	 */
	secondAdditionalComponent?: JSX.Element
	/**
	 * Reference numbers path do be displayed, eg. "Lead xxx > Quote yyy" (element[0] > element[1] etc.)
	 */
	refNumPath?: Array<string | DetailsStatusPathItem>;
}

export const CommonDetailsStatusRow: React.SFC<IProps> = (props) => {
	return (
		<div className="c-common-status">
			<div>
				{props.refNumPath && renderRefNumPathItems(props.refNumPath)}
				<div className="c-common-status_row-container">
					{props.onBackClick && <div className="c-common-status_back-button-container" onClick={props.onBackClick}>
						<IconLarge variant={"burgundy"} icon={Icon.ArrowLeft}/>
					</div>}
					{props.icon && <div className="c-common-status_quote-icon-container"><IconLarge icon={props.icon}/></div>}
					<div className="c-common-status_quote-text">{props.title}</div>
					{renderStatus(props.status, props.customStatusComponent)}
					{props.additionalComponent}
				</div>
			</div>
			{props.secondAdditionalComponent &&
			<div className="c-common-status_right-column">
				{props.secondAdditionalComponent}
			</div>
			}
		</div>
	);
};

const renderStatus = (status: string, customStatusComponent: JSX.Element) => {
	return (
		customStatusComponent ?
			customStatusComponent : status ?
			<div className="c-common-status_status-wrapper">
				<div className="c-common-status_status-text">{status}</div>
			</div> : null
	);
};

const renderRefNumPathItems = (items: Array<string | DetailsStatusPathItem>) => {
	return (
		<div className="c-common-status_ref-nums-container">
			{items.map((item, index) => {
				let label: string;
				let onClick: () => void;
				if (item) {
					const isItemString: boolean = typeof item === "string";
					label = isItemString ? item as string : (item as DetailsStatusPathItem).label;
					onClick = isItemString ? null : (item as DetailsStatusPathItem).onClick;
				}
				const classFromProps = classNames({
					"c-common-status_lead-ref-num": true,
					"is-clickable": !!onClick
				});
				if (index === items.length - 1) {
					return <div key={index} className="c-common-status_quote-ref-num" onClick={onClick}>{label}</div>;
				}
				return (
					<div key={index} style={{display: "inline"}}>
						<div className={classFromProps} onClick={onClick}>{label}</div>
						<div className="c-common-status_ref-num-arrow">
							<IconWrapper variant={"lighterBlue"} icon={Icon.ArrowRight} size={11}/>
						</div>
					</div>
				);
			})}
		</div>
	);
};
